import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";

export default function SidebarScroll({ children }) {
  const scrollContainerRef = useRef();
  const [height, setHeight] = useState();
  const [hasHiddenAbove, setHasHiddenAbove] = useState(false);
  const [hasHiddenBelow, setHasHiddenBelow] = useState(false);

  const updateOverflowCues = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    setHasHiddenAbove(container.scrollTop > 1);
    setHasHiddenBelow(
      container.scrollTop + container.clientHeight < container.scrollHeight - 1
    );
  };

  const scrollToEdge = (top) => {
    scrollContainerRef.current?.scrollTo({ top, behavior: "smooth" });
  };

  const startResize = (event) => {
    event.preventDefault();
    const container = scrollContainerRef.current;
    const startY = event.clientY;
    const startHeight = container.clientHeight;

    const resize = (moveEvent) => {
      setHeight(
        Math.min(
          window.innerHeight - 20,
          Math.max(40, startHeight + moveEvent.clientY - startY)
        )
      );
    };
    const stopResize = () => {
      window.removeEventListener("pointermove", resize);
      window.removeEventListener("pointerup", stopResize);
    };

    window.addEventListener("pointermove", resize);
    window.addEventListener("pointerup", stopResize);
  };

  useEffect(() => {
    updateOverflowCues();

    const resizeObserver = new ResizeObserver(updateOverflowCues);
    resizeObserver.observe(scrollContainerRef.current);

    return () => resizeObserver.disconnect();
  }, [children]);

  return (
    <div className="position-relative">
      <div
        ref={scrollContainerRef}
        style={{
          height,
          minHeight: 40,
          maxHeight: height ? "calc(100vh - 20px)" : "50vh",
          overflowY: "auto",
        }}
        onScroll={updateOverflowCues}
      >
        {children}
      </div>
      <div
        aria-label="Resize section"
        className="position-absolute bottom-0 start-0 w-100"
        style={{ height: 6, cursor: "ns-resize", zIndex: 3 }}
        onPointerDown={startResize}
      />
      {hasHiddenAbove && (
        <button
          type="button"
          aria-label="Scroll to top"
          className="position-absolute top-0 start-0 w-100 d-flex justify-content-center align-items-center border-0 text-white"
          style={{
            height: 20,
            zIndex: 1,
            background:
              "linear-gradient(to bottom, rgba(108, 117, 125, 0.5), transparent)",
          }}
          onClick={() => scrollToEdge(0)}
        >
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
      )}
      {hasHiddenBelow && (
        <button
          type="button"
          aria-label="Scroll to bottom"
          className="position-absolute bottom-0 start-0 w-100 d-flex justify-content-center align-items-center border-0 text-white"
          style={{
            height: 20,
            zIndex: 1,
            background:
              "linear-gradient(to top, rgba(108, 117, 125, 0.5), transparent)",
          }}
          onClick={() => scrollToEdge(scrollContainerRef.current.scrollHeight)}
        >
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
      )}
    </div>
  );
}
